import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const CountdownModal = ({ show, onClose, endConversation }) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (show) {
      setKey(prev => prev + 1);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      contentClassName="rounded-5 bg-white"
    >
      <div className="p-4">

        <div className="p-3">
          <div className="fw-semibold fs-4 text-danger" style={{textAlign:"center"}}>
            Conversation will end in
          </div>
        </div>

        <div className="d-flex justify-content-center my-2">
          <CountdownCircleTimer
            key={key}
            isPlaying={show}
            duration={30}
            colors={["#198754", "#ffc107", "#dc3545"]}
            colorsTime={[15, 10, 5]}
            size={200}
            strokeWidth={18}
            onComplete={() => {
              endConversation?.();  // ONLY here
              onClose();
              return { shouldRepeat: false };
            }}
          >
            {({ remainingTime }) => (
             <div className="d-flex flex-column align-items-center">
              <div className="display-4 fw-bold text-dark">
                {remainingTime}
              </div>
              <div className="fs-6 text-muted">
                Seconds
              </div>
            </div>
            )}
          </CountdownCircleTimer>
        </div>

        <div className="d-flex justify-content-center mt-3 pt-1">
          <Button
            variant="primary"
            className="rounded-pill px-4"
            onClick={onClose}
          >
            Close
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default CountdownModal;